import React, { useState, useCallback, useEffect } from 'react';
import { motion } from 'framer-motion';

import CloseIcon from "../../assets/images/close.png";

import { connect } from "react-redux";
import { compose } from "redux";

import { Disable } from 'react-disable';
import debounce from "lodash/debounce";

import { getUsers } from "../../store/actions/adminActions";
import { getNotificationsSettings, addNotificationUser, removeNotificationUser, editNotificationUser } from "../../store/actions/departmentActions";

import Select from 'react-select'



function Avatar({ name, src, size = 28 }) {
    const [errored, setErrored] = React.useState(false);

    const initials = (name || "")
        .split(" ")
        .map((s) => s[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();

    if (!src || errored) {
        return (
            <div
                className="flex items-center justify-center rounded-full border border-gray-300 bg-gray-100 text-gray-500"
                style={{ width: size, height: size }}
                title={name}
            >
                <svg
                    width={Math.floor(size * 0.6)}
                    height={Math.floor(size * 0.6)}
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                >
                    <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 1c-3.33 0-6 1.34-6 3v2h12v-2c0-1.66-2.67-3-6-3Z" />
                </svg>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={name}
            title={name}
            loading="lazy"
            referrerPolicy="no-referrer"
            className="rounded-full object-cover border border-gray-300 bg-white"
            style={{ width: size, height: size }}
            onError={() => setErrored(true)}
        />
    );
}

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};

const Toggle = ({ checked, onChange }) => {
    return (
        <label className="relative inline-block cursor-pointer">
            <input
                type="checkbox"
                className="sr-only"
                checked={checked}
                onChange={(e) => onChange(e)}
            />
            <div
                className="bg-[#111827] text-white px-4 py-2 rounded-lg text-[13px] font-medium hover:bg-[#1F2937] transition"
            >
                <div
                    className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ${checked ? 'translate-x-5' : 'translate-x-0'
                        }`}
                />
            </div>
        </label>
    );
};

const NotificationsOverlay = ({ close, department, getUsersFN, users, getNotificationsSettingsFN, addNotificationUserFN, removeNotificationUserFN, notifications_settings, editNotificationUserFN }) => {


    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('participants');
    const [editmode, setEditmode] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [editUser, setEditUser] = useState(null);



    useEffect(() => {
        getUsersFN();
        getNotificationsSettingsFN(department.department_id);
    }, []);

    //update edituser with notifications_settings
    useEffect(() => {
        if (notifications_settings && notifications_settings?.length > 0) {
            setEditUser(notifications_settings?.find(option => option.user_id === editUser?.user_id));
        }
    }, [notifications_settings]);



    const usersOptions = users && users?.length > 0 ? users.map((user) => ({
        value: user.user_id,
        label: user.first_name + " " + user.last_name
    })) : [];

    const partecipantsOptions = notifications_settings?.map((participant) => ({
        value: participant.user_id,
        label: users?.find(u => u.user_id === participant.user_id)?.first_name + " " + users?.find(u => u.user_id === participant.user_id)?.last_name
    }));

    const filteredParticipants = notifications_settings?.filter(participant => {
        const user = users?.find(u => u.user_id === participant.user_id);
        if (!user) return false;

        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
        return fullName.includes(searchTerm.toLowerCase());
    });


    const selectedUser_parameters = notifications_settings && notifications_settings?.length > 0 ? notifications_settings?.find(participant => participant.user_id === editUser?.user_id) : null;

    console.log(department);



    return (
        <Disable disabled={isLoading}>
            <div className="w-full bg-[#F8F8F8] py-8 min-h-[calc(100vh-64px)]">

                <div className="max-w-[1400px] mx-auto bg-white border border-[#E5E7EB] rounded-2xl shadow-sm flex flex-col">

                    {/* Header */}
                    <div className="px-8 py-6 border-b border-[#E5E7EB] flex items-center justify-between">
                        {/* Department Info */}
                        <div className="flex items-center gap-4 min-w-0">
                            <div
                                title={department.name}
                                className="flex items-center justify-center w-11 h-11 rounded-2xl shrink-0 shadow-sm"
                                style={{ backgroundColor: department.color || "#3b3b3b" }}
                            >
                                <span className="text-white font-bold text-[13px]">
                                    {department.name
                                        ?.split(" ")
                                        .filter((word) => word.toLowerCase() !== "and")
                                        .map((word) => word.charAt(0).toUpperCase())
                                        .slice(0, 2)
                                        .join("") || "D"}
                                </span>
                            </div>

                            <div className="min-w-0">
                                <h2 className="text-[22px] font-semibold text-[#111827] truncate">
                                    {department.name || "Department"}
                                </h2>
                                <p className="text-[13px] text-[#6B7280] mt-1">
                                    Manage participants and notification configuration
                                </p>
                            </div>
                        </div>

                        {/* Tabs */}
                        <div className="flex items-center gap-2 bg-[#F3F4F6] border border-[#E5E7EB] rounded-xl p-1">
                            {["participants", "configuration"].map((tab) => (
                                <button
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    className={`px-5 py-2 rounded-lg text-[13px] font-medium capitalize transition-all ${activeTab === tab
                                            ? "bg-white text-[#111827] shadow-sm"
                                            : "text-[#6B7280] hover:text-[#111827]"
                                        }`}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                    </div>



                    {/* Tab Content */}
                    <div className="w-full px-8 py-6">
                        {activeTab === 'participants' && (
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -10 }}
                                transition={{ duration: 0.2 }}
                                className="relative"
                            >
                                {!editmode && (
                                    <div className="space-y-4">
                                        <div className="flex justify-between items-center">
                                            <button
                                                className="bg-[#111827] text-white px-4 py-2 rounded-lg text-[13px] font-medium hover:bg-[#1F2937] transition"
                                                onClick={() => setEditmode(true)}
                                            >
                                                <i className="fa fa-plus"></i> Add Participant
                                            </button>
                                            {notifications_settings && notifications_settings?.length > 0 && <div className="relative">
                                                <input
                                                    type="text"
                                                    placeholder="Search by name..."
                                                    className="pl-8 pr-4 py-2 border rounded-md bg-gray-50 focus:outline-none focus:ring-1 focus:ring-[#3b3b3b] focus:border-[#3b3b3b]"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                                <i className="fa fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                                            </div>}

                                        </div>

                                        {notifications_settings && notifications_settings?.length > 0 ? (
                                            <div className="bg-gray-50 rounded-xl border border-[#E5E7EB] overflow-x-auto">
                                                <table className="min-w-full divide-y divide-gray-200">
                                                    <thead className="bg-gray-100">
                                                        <tr>
                                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Title</th>
                                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                                                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="bg-white divide-y divide-gray-200">
                                                        {filteredParticipants && filteredParticipants?.length > 0 ? (
                                                            filteredParticipants.map((participant) => {
                                                                const user = users?.find(u => u.user_id === participant.user_id);
                                                                if (!user) return null;

                                                                return (
                                                                    <tr key={participant.user_id} className="hover:bg-gray-50">
                                                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                                            {user.first_name} {user.last_name}
                                                                        </td>
                                                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                            {user.title || 'N/A'}
                                                                        </td>
                                                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                            {user.role || 'User'}
                                                                        </td>
                                                                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm">

                                                                            <button
                                                                                onClick={() => { setEditUser(participant); setActiveTab('configuration'); }}
                                                                                className="text-gray-500 hover:text-gray-900 mr-4"
                                                                            >
                                                                                <i className="fa fa-edit text-lg "></i>
                                                                            </button>


                                                                            <button
                                                                                onClick={() => { removeNotificationUserFN(department.department_id, participant.user_id); setEditmode(false); }}
                                                                                className="text-red-600 hover:text-red-900"
                                                                            >
                                                                                <i className="fa fa-trash text-lg"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="4" className="px-6 py-4 text-center text-sm text-gray-500">
                                                                    No participants found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>) : (
                                            <div className="flex justify-center items-center">
                                                <span className="text-gray-500">No participants found</span>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {editmode && (
                                    <div className="relative z-10">
                                        <div className="flex flex-col gap-2 mb-4">
                                            <Select
                                                options={usersOptions}
                                                onChange={(e) => setSelectedUser(e.value)}
                                                styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        minHeight: 46,
                                                        borderRadius: 12,
                                                        borderColor: state.isFocused ? "#111827" : "#E5E7EB",
                                                        boxShadow: state.isFocused ? "0 0 0 1px #111827" : "none",
                                                        "&:hover": {
                                                            borderColor: "#111827",
                                                        },
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        borderRadius: 14,
                                                        overflow: "hidden",
                                                        boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
                                                        border: "1px solid #E5E7EB",
                                                        zIndex: 9999,
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: state.isFocused ? "#F3F4F6" : "white",
                                                        color: "#111827",
                                                        padding: "10px 12px",
                                                        cursor: "pointer",
                                                    }),
                                                }}
                                                formatOptionLabel={(u) => (
                                                    <div className="flex items-center gap-3">
                                                        <Avatar name={u.label} src={u.avatar} size={28} />

                                                        <div className="flex flex-col leading-tight">
                                                            <span className="text-[13px] font-medium text-[#111827]">
                                                                {u.label}
                                                            </span>
                                                            <span className="text-[11px] text-[#6B7280]">
                                                                {u.title || u.role || "User"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                                placeholder="Select a participant..."
                                            />
                                        </div>

                                        <button className="bg-[#3b3b3b] text-white px-4 py-2 rounded-md hover:bg-opacity-90" onClick={() => { if (selectedUser) { addNotificationUserFN(department.department_id, selectedUser); setSelectedUser(null); setEditmode(false); } else { alert("Please select a user") } }}><i className="fa fa-plus"></i> Add Participant</button>

                                        <button className="bg-[#3b3b3b] text-white px-4 py-2 rounded-md hover:bg-opacity-90 ml-4" onClick={() => setEditmode(false)}><i className="fa fa-times"></i> Close Edit Mode</button>
                                    </div>
                                )}
                            </motion.div>
                        )}

                        {activeTab === 'configuration' && (
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: -10 }}
                                transition={{ duration: 0.2 }}
                            >
                                <div className="relative z-10">
                                    <div className="flex flex-col gap-2 mb-4">
                                        <Select
                                            options={partecipantsOptions}
                                            onChange={(e) => setEditUser(notifications_settings?.find(option => option.user_id === e.value))}
                                            styles={customStyles}
                                            value={partecipantsOptions.find(option => option.value === editUser?.user_id)}
                                            placeholder="Select a participant.."
                                        />
                                    </div>


                                    {editUser && <div className="bg-gray-50 rounded-xl border border-[#E5E7EB] overflow-x-auto">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-100">
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Occasion</th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">E-mail</th>
                                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">App notification</th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                <tr className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        Assign task
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_assign_task}
                                                                onChange={(e) => {
                                                                    if (!editUser) {
                                                                        alert("Please select a user");
                                                                        return;
                                                                    }
                                                                    const notify_assign_task = e.target.checked;
                                                                    editNotificationUserFN(department.department_id, editUser.user_id, notify_assign_task, editUser.notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={false}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        Deadline -5/+5 days
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_deadline}
                                                                onChange={(e) => {
                                                                    if (!editUser) {
                                                                        alert("Please select a user");
                                                                        return;
                                                                    }
                                                                    const notify_deadline = e.target.checked;
                                                                    editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={false}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        Comment
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_comment}
                                                                onChange={(e) => {
                                                                    if (!editUser) {
                                                                        alert("Please select a user");
                                                                        return;
                                                                    }
                                                                    const notify_comment = e.target.checked;
                                                                    editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={false}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        Delete risk
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_delete_risk}
                                                                onChange={(e) => {
                                                                    if (!editUser) {
                                                                        alert("Please select a user");
                                                                        return;
                                                                    }
                                                                    const notify_delete_risk = e.target.checked;
                                                                    editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, editUser.notify_comment, notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={false}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        Delete control
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_delete_control}
                                                                onChange={(e) => {
                                                                    if (!editUser) {
                                                                        alert("Please select a user");
                                                                        return;
                                                                    }
                                                                    const notify_delete_control = e.target.checked;
                                                                    editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, notify_delete_control, editUser.notify_delete_action, editUser.notify_modify_timeline);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={false}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        Delete action
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_delete_action}
                                                                onChange={(e) => {
                                                                    if (!editUser) {
                                                                        alert("Please select a user");
                                                                        return;
                                                                    }
                                                                    const notify_delete_action = e.target.checked;
                                                                    editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, notify_delete_action, editUser.notify_modify_timeline);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={false}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        Modify timeline for actions
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={notifications_settings?.find(option => option.user_id === editUser?.user_id)?.notify_modify_timeline}
                                                                onChange={(e) => {
                                                                    if (!editUser) {
                                                                        alert("Please select a user");
                                                                        return;
                                                                    }
                                                                    const notify_modify_timeline = e.target.checked;
                                                                    editNotificationUserFN(department.department_id, editUser.user_id, editUser.notify_assign_task, editUser.notify_deadline, editUser.notify_comment, editUser.notify_delete_risk, editUser.notify_delete_control, editUser.notify_delete_action, notify_modify_timeline);
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                        <div className="flex justify-center items-center">
                                                            <Toggle
                                                                checked={false}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>}



                                </div>
                            </motion.div>
                        )}
                    </div>
                </div>
            </div>
        </Disable >
    );
};



const mapStateToProps = (state) => {
   

    const normalizedNotifications =
        Array.isArray(state.department.notifications_settings)
            ? state.department.notifications_settings
            : state.department.notifications_settings && Array.isArray(state.department.notifications_settings.data)
                ? state.department.notifications_settings.data
                : [];

    const users = (state.admin.admin_users || []).filter(
        (u) => ["user", "auditor"].includes((u.role || "").toLowerCase())
    );

     console.log("Users ", users)
    return {
        users: users,
        notifications_settings: normalizedNotifications
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUsersFN: () => dispatch(getUsers()),
        getNotificationsSettingsFN: (department_id) => dispatch(getNotificationsSettings(department_id)),
        addNotificationUserFN: (department_id, user_id) => dispatch(addNotificationUser(department_id, user_id)),
        removeNotificationUserFN: (department_id, user_id) => dispatch(removeNotificationUser(department_id, user_id)),
        editNotificationUserFN: (department_id, user_id, notify_assign_task, notify_deadline, notify_comment, notify_delete_risk, notify_delete_control, notify_delete_action, notify_modify_timeline) => dispatch(editNotificationUser(department_id, user_id, notify_assign_task, notify_deadline, notify_comment, notify_delete_risk, notify_delete_control, notify_delete_action, notify_modify_timeline))
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(NotificationsOverlay);